import React from "react";
import Wordmark from "@/components/Wordmark";

const FOOTER_NAV = [
  { label: "Home", href: "/#home" },
  { label: "Services", href: "/#services" },
  { label: "Products", href: "/#studio" },
  { label: "Work", href: "/#work" },
  { label: "About", href: "/#about" },
  { label: "Contact", href: "/#contact" },
];

const FOOTER_SERVICES = [
  "Website Development",
  "Mobile App Development",
  "Web Apps & SaaS",
  "Business Systems",
  "AI-Powered Products",
  "Product Studio",
];

const LEGAL = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Cookie Notice", href: "/cookies" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 pb-10 border-t border-white/10 bg-[#06101D]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <Wordmark />
            <p className="mt-5 text-[15px] text-slate-400 max-w-sm leading-relaxed">
              Web, app and digital product development studio. Helping UK businesses
              design, build and launch modern technology.
            </p>
            <div className="mt-7 space-y-1.5 text-[13px] text-slate-400 leading-relaxed">
              <div className="text-white font-medium">Mackbe Tech Ltd</div>
              <div>400 Thames Valley Park Dr</div>
              <div>Earley, Reading, RG6 1PT</div>
              <div>United Kingdom</div>
              <a
                href="mailto:hello@mackbetech.com"
                className="inline-block pt-1 mk-underline-link text-slate-300"
                data-testid="footer-email-link"
              >
                hello@mackbetech.com
              </a>
            </div>
            <p className="mt-7 text-[11px] uppercase tracking-[0.22em] text-slate-500">
              Trading since October 2019
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
              Navigate
            </div>
            <ul className="mt-5 space-y-3">
              {FOOTER_NAV.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-nav-${l.label.toLowerCase()}-link`}
                    className="text-[14px] text-slate-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-8 text-[11px] uppercase tracking-[0.22em] text-slate-500">
              Legal
            </div>
            <ul className="mt-5 space-y-3">
              {LEGAL.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-legal-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-link`}
                    className="text-[14px] text-slate-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500">
              Services
            </div>
            <ul className="mt-5 space-y-3">
              {FOOTER_SERVICES.map((s) => (
                <li key={s}>
                  <a
                    href="/#services"
                    data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-link`}
                    className="text-[14px] text-slate-300 hover:text-white transition-colors"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-7 border-t border-white/10 flex flex-col gap-5">
          <p
            className="text-[14px] text-slate-400 max-w-3xl leading-relaxed"
            data-testid="footer-positioning-line"
          >
            Focused on delivering practical, high-quality digital solutions that
            support real business growth.
          </p>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
            <p className="text-[13px] text-slate-500">
              © 2026 Mackbe Tech Ltd. All rights reserved.
            </p>
            <p className="text-[13px] text-slate-500">
              Registered in England · Reading, UK
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
